module.exports = __webpack_public_path__ + "img/liveBroadcast.11aa1b60.png";